import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./style.scss";
import Painel from "gp-painel";
import "gp-painel/dist/index.css";
import { Secured } from "../../component";
import { Permissions } from "../../Constantes/permissions.constants";
import imagemAvatar from "../../imagens/avatar.png";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import {
  Col,
  Form,
  Row,
  Modal,
  message,
  Alert,
  Card,
  Progress,
  Button,
  Popover,
  Input,
  DatePicker,
} from "antd";
import ModalHistorico from "./modalHistorico";
import {
  Contato,
  Endereco,
  IdentificacaoPessoa,
} from "./Componentes/Componentes";
import StatusBeneficios from "../../component/StatusBeneficios";
import { Message } from "../../Constantes/message.constants";
import Parser from "html-react-parser";

import service from "./services";
import ModalFoto from "../../component/ModalFoto";
import ModalDependente from "../../component/Dependentes/ModalDependente";

import moment from "moment";

import PermiteContato from "../../component/PermiteContato/PermiteContato";
import InputCPF from "./Componentes/Input-CPF";

import IdentificacaoBase from "../../component/IdentificacaoDoSegurado/Identificacao-base";

import { RetificacaoContext } from "../../component/Context/RetificacaoContext";
import BloqueioJuntaMedica from "../../component/BloqueioJuntaMedica/bloqueioJuntaMedica";

import BloqueioProvaDeVida from "../../component/BloqueioProvaDeVida/bloqueioProvaDeVida";

import ModalConfirmacaoRecadastramento from "../Recadastramento/Componentes/Modal-Documentacao";

import { useModoSomenteLeitura } from "../../component/Security/useModoSomenteLeitura";


const statusAlert = {
  warn: { tipo: "warning", titulo: "Aviso" },
};

const Recadastramento = () => {
  //const [modoSomenteLeitura, setModoSomenteLeitura] = React.useState(false);
  const modoSomenteLeitura = useModoSomenteLeitura();
  const [form] = Form.useForm();
  const [valoresForm, setValoresForm] = React.useState({});
  const [ocultarEtapa2, setOcultarEtapa2] = React.useState(true);
  const [ocultarEtapa3, setOcultarEtapa3] = React.useState(true);
  const [recadastramento, setRecadastramento] = React.useState(false);
  const [mostrarModalHistorico, setMostrarModalHistorico] =
    React.useState(false);
  const [mostrarModalRepresentante, setMostrarModalRepresentante] =
    React.useState(false);
  const [existeBeneficioPensao, setExisteBeneficioPensao] =
    React.useState(false);
  const [exibeMensagemRepresentante, setExibeMensagemRepresentante] =
    React.useState(false);
  const [requerRepresentante, setRequerRepresentante] = React.useState(false);
  const history = useHistory();
  const controleEtapa2 = () => setOcultarEtapa2(false);
  const [fotoBase64, setFotoBase64] = React.useState();
  const [documentoBase64, setDocumentoBase64] = React.useState();
  const [certidaoBase64, setCertidaoBase64] = React.useState();
  const [modalFotoEstaAberto, setModalFotoEstaAberto] = React.useState(false);

  const pessoaId = form.getFieldValue(["pessoaBanco", "id"]);

  const [ultimaFotoCensoBase64, setUltimaFotoCensoBase64] = React.useState();

  const [emissaoDeclaracao, setEmissaoDeclaracao] = React.useState(false);

  const [erroObrigatorio, setErroObrigatorio] = useState(false);

  const { Meta } = Card;

  const permiteContato = Form.useWatch(["pessoa", "autorizaContato"], form);

  const [mostrarModalDependente, setMostrarModalDependente] =
    React.useState(false);

  const [mostrarBloqueio, setMostrarBloqueio] = useState(false);
  const [mostrarBloqueioProvaDeVida, setMostrarBloqueioProvaDeVida] =
    useState(false);

  const [mensagemErro, setMensagemErro] = useState("");

  const [mostrarModalConfirmacao, setMostrarModalConfirmacao] = useState(false);
  const [possuiAposentadoria, setPossuiAposentadoria] = useState(false);

  const sanitizeDeep = (obj) => {
    if (obj === null || obj === undefined) return obj;

    if (moment.isMoment(obj)) return obj;

    if (obj instanceof Date) return obj;

    if (typeof obj === "string") {
      return obj.trim();
    }

    if (Array.isArray(obj)) {
      return obj.map(sanitizeDeep);
    }

    if (typeof obj === "object" && obj !== null) {
      const result = {};
      Object.keys(obj).forEach((key) => {
        result[key] = sanitizeDeep(obj[key]);
      });
      return result;
    }

    return obj;
  };

  React.useEffect(() => {
    form.setFieldsValue(sanitizeDeep(valoresForm));

    setExisteBeneficioPensao(
      valoresForm?.beneficios?.filter((item) => item.pensao).length > 0
    );

    //setPossuiAposentadoria(!!valoresForm?.possuiAposentadoria);

    setPossuiAposentadoria(
      valoresForm?.beneficios?.some((b) => b.aposentadoria)
    );
  }, [valoresForm]);

  const location = history.location;
  const dadosOrigem = location.state;

  const ctx = React.useContext(RetificacaoContext);

  const base64ToBlob = (base64Data, contentType) => {
    // Remove o prefixo "data:image/jpeg;base64," ou similar, se presente
    const base64Clean = base64Data.split(",")[1]; // Apenas pega a parte após o vírgula

    const byteCharacters = atob(base64Clean); // Decodifica a string Base64
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: contentType });
  };

  React.useEffect(() => {
    if (fotoBase64) {
      const imagemBlob = base64ToBlob(fotoBase64, "image/jpeg");

      valoresForm.imagemDaFoto = imagemBlob;
    }
  }, [fotoBase64]);

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // <-- Converte para Base64 de verdade
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const visualizarArquivo = async (file, tipoDocumento) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    if (tipoDocumento === "Documento") {
      setDocumentoBase64(file.url || file.preview);
    }

    if (tipoDocumento === "Certidao") {
      setCertidaoBase64(file.url || file.preview);
    }
  };

  const emitirComprovante = async (id) => {
    if (!id) {
      message.warning("Não foi possível emitir o comprovante.");
      return;
    }

    try {
      await service.visualizar(id);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Erro ao emitir o comprovante.";

      message.error(errorMessage, 4);
      console.error("Erro ao emitir comprovante:", error);
    }
  };

  const handleChangeDocumento = async (info, tipoDocumento) => {
    if (!info) return;

    const file =
      info.file?.originFileObj ||
      info.file?.file ||
      info.file ||
      info?.target?.files?.[0];
    if (!file) return;

    const tiposDeArquivosValidos = ["application/pdf"];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB

    if (!tiposDeArquivosValidos.includes(file.type)) {
      message.error("Apenas arquivos PDF são permitidos.", 4);
      return;
    }

    if (file.size > maxFileSize) {
      message.error("O arquivo selecionado excede 5 MB.", 4);
      return;
    }

    try {
      const base64 = await getBase64(file);

      if (tipoDocumento === "Documento") {
        setDocumentoBase64(base64);
        valoresForm.arquivoDocumentos = file;
      } else if (tipoDocumento === "Certidao") {
        setCertidaoBase64(base64);
        valoresForm.arquivoCertidao = file;
      }
    } catch (error) {
      console.warn("Erro ao converter para Base64:", error);
      message.error("Erro ao ler o arquivo. Tente novamente.", 4);
    }
  };

  const downloadArquivo = (base64String, fileName) => {
    if (!base64String?.startsWith("data:application/pdf;base64,")) {
      base64String = `data:application/pdf;base64,${base64String}`;
    }

    const link = document.createElement("a");
    link.href = base64String;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleValoresCPF = (dadosDoFormulario) => {
    const dadosNormalizados = {
      ...dadosDoFormulario,
      pessoa: {
        ...dadosDoFormulario.pessoa,
        nascimento: toMomentOrNull(dadosDoFormulario?.pessoa?.nascimento),
      },
      pessoaBanco: {
        ...dadosDoFormulario.pessoaBanco,
        expedicaoPassaporte: toMomentOrNull(
          dadosDoFormulario.pessoaBanco.expedicaoPassaporte
        ),
        validadePassaporte: toMomentOrNull(
          dadosDoFormulario.pessoaBanco.validadePassaporte
        ),
        expedicaoCarteiraProfissional: toMomentOrNull(
          dadosDoFormulario.pessoaBanco.expedicaoCarteiraProfissional
        ),
        validadeCarteiraProfissional: toMomentOrNull(
          dadosDoFormulario.pessoaBanco.validadeCarteiraProfissional
        ),
        dataDeNascimento: toMomentOrNull(
          dadosDoFormulario.pessoaBanco.dataDeNascimento
        ),

        expedicaoIdentidade: toMomentOrNull(
          dadosDoFormulario.pessoaBanco.expedicaoIdentidade
        ),
        validadeHabilit: toMomentOrNull(
          dadosDoFormulario.pessoaBanco.validadeHabilit
        ),
        emissaoHabilit: toMomentOrNull(
          dadosDoFormulario.pessoaBanco.emissaoHabilit
        ),
      },
    };

    setValoresForm(sanitizeDeep(dadosNormalizados));

    setUltimaFotoCensoBase64(
      dadosNormalizados.ultimaFotoCensoBase64
        ? `data:image/jpeg;base64,${dadosNormalizados.ultimaFotoCensoBase64}`
        : undefined
    );
    setRequerRepresentante(
      IdentificacaoPessoa.checandoDiferencaEntreDatas(
        dadosNormalizados?.pessoa?.nascimento
      )
    );
    controleEtapa2(true);
  };

  const cancelar = () => {
    form.resetFields();
    form.setFieldsValue({
      documentoApresentado: null,
    });
    setValoresForm(null);
    setExibeMensagemRepresentante(false);
    controleEtapa2(false);
    setOcultarEtapa3(true);
    setOcultarEtapa2(true);
    setRecadastramento(false);
    setEmissaoDeclaracao(false);
    setTipoConfirmacao("RECADASTRAMENTO");
    setErroObrigatorio(false);

  };

  const finalizarRecadastramento = async (data) => {
    setErroObrigatorio(false);
    data.endereco.cidade = data?.endereco?.cidade?.split("__")?.[0] || "";
    const formComReferencia = {
      ...valoresForm,
      dataReferenciaTela: valoresForm?.referencia || new Date().getFullYear(),
      pessoa: {
      ...valoresForm.pessoa,

        carteirasTrabalho:
          valoresForm?.pessoa?.carteirasTrabalho?.map((carteira) => ({
            ...carteira,
            dataExpedicao: carteira.dataExpedicao
              ? `${carteira.dataExpedicao}T00:00:00`
              : null,
          })),
      },
    };

    data.pessoaBanco.autorizaContato = permiteContato;

    service
      .formatarRequisicao(formComReferencia, data)
      .then((objetoFormatado) => service.finalizar(objetoFormatado))
      .then((response) => {
        if (response.data) {
          const idCenso = response.data?.idCenso;

          message.success(Message.MSG005_RECADASTRO_SUCESSO, 4);

          emitirComprovante(idCenso);

          history.push(
            `/recadastramento/censo/${valoresForm.pessoa.cpf}/${response.data?.idCenso}`,
            {
              forceRedirect: true,
            }
          );
        } else {
          console.error("Resposta inesperada da API:", response);
        }
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message ||
          "Erro desconhecido ao finalizar recadastramento.";

        message.error(errorMessage, 4);
        console.error("Erro ao finalizar recadastramento:", error);
      });
  };

  const confirmarRecadastramento = async (data) => {
    try {
      await form.validateFields();

      Modal.confirm({
        title: "Confirmação",
        content: `Deseja finalizar o recadastramento de ${data.pessoa.nome} para o ano ${valoresForm?.referencia}?`,
        okText: "Sim",
        onOk: () => finalizarRecadastramento(data),
      });
    } catch (error) {
      handleErroValidacao();
    }
  };

  /*const obterCPF = (cpf) => {
    service
      .obterCPF(cpf, true)
      .then((result) => result.data)
      .then((dados) => {
        form.resetFields();
        IdentificacaoPessoa.processarDados(dados, handleValoresCPF);
        setUltimaFotoCensoBase64(
          dados.ultimaFotoCensoBase64
            ? `data:image/jpeg;base64,${dados.ultimaFotoCensoBase64}`
            : undefined
        );
      });
  };*/

  const obterCPF = (cpf) => {
    const documentoApresentado = form.getFieldValue("documentoApresentado");
    service
      .obterCPF(cpf, true)
      .then((result) => result.data)
      .then((dados) => {
        form.resetFields();
        IdentificacaoPessoa.processarDados(dados, handleValoresCPF);

        setUltimaFotoCensoBase64(
          dados.ultimaFotoCensoBase64
            ? `data:image/jpeg;base64,${dados.ultimaFotoCensoBase64}`
            : undefined
        );

        form.setFieldsValue({
          documentoApresentado: documentoApresentado,
        });
      })
      .catch((error) => {
        const data = error.response?.data;

        if (data?.codigo === "BLOQUEIO_JUNTA_MEDICA") {
          setMensagemErro(data.mensagem);
          setMostrarBloqueio(true);
          return;
        }

        if (data?.codigo === "BLOQUEIO_PROVA_DE_VIDA") {
          setMensagemErro(data.mensagem);
          setMostrarBloqueioProvaDeVida(true);
          return;
        }

        message.error(data?.mensagem || "Erro ao buscar CPF.", 4);
      });
  };

  React.useEffect(() => {
    if (!ctx.dadosRetificacao) return;

    const dados = ctx.dadosRetificacao.dados;

    setValoresForm(sanitizeDeep(dados));
    form.setFieldsValue(sanitizeDeep(dados));
    setUltimaFotoCensoBase64(dados.ultimaFotoCensoBase64);

    setOcultarEtapa2(false);
    setOcultarEtapa3(false);

    ctx.setDadosRetificacao(null);
  }, [ctx.dadosRetificacao]);

  const retificarCPF = (id, anoReferencia, cpf) => {
    // 1. Obter dados do CPF
    service
      .obterCPF(cpf, true)
      .then((res) => res.data)
      .then((dados) => {
        // 2. Atualizar valores do formulário

        setUltimaFotoCensoBase64(
          dados.ultimaFotoCensoBase64
            ? `data:image/jpeg;base64,${dados.ultimaFotoCensoBase64}`
            : undefined
        );

        dados = {
          ...dados,
          pessoa: {
            ...dados.pessoa,
            nascimento: toMomentOrNull(dados.pessoa.nascimento),
          },
          pessoaBanco: {
            ...dados.pessoaBanco,
            expedicaoPassaporte: toMomentOrNull(
              dados.pessoaBanco.expedicaoPassaporte
            ),
            validadePassaporte: toMomentOrNull(
              dados.pessoaBanco.validadePassaporte
            ),
            expedicaoCarteiraProfissional: toMomentOrNull(
              dados.pessoaBanco.expedicaoCarteiraProfissional
            ),
            validadeCarteiraProfissional: toMomentOrNull(
              dados.pessoaBanco.validadeCarteiraProfissional
            ),
            dataDeNascimento: toMomentOrNull(
              dados.pessoaBanco.dataDeNascimento
            ),

            expedicaoIdentidade: toMomentOrNull(
              dados.pessoaBanco.expedicaoIdentidade
            ),
            validadeHabilit: toMomentOrNull(dados.pessoaBanco.validadeHabilit),
            emissaoHabilit: toMomentOrNull(dados.pessoaBanco.emissaoHabilit),
          },
        };
        dados.id = id;
        dados.referencia = anoReferencia;

        setDocumentoBase64(undefined);
        setCertidaoBase64(undefined);
        setFotoBase64(undefined);

        setValoresForm(sanitizeDeep(dados));

        // 3. Garantir que todas as etapas sejam exibidas
        setOcultarEtapa2(false);
        setOcultarEtapa3(false);
        setRecadastramento(false);
        setEmissaoDeclaracao(false);

        // 4. Atualiza o form
        form.setFieldsValue(sanitizeDeep(dados));
      });
  };

  const handleErroValidacao = () => {
    setErroObrigatorio(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const imprimirDeclaResponsabilidade = () => {
    const formValues = form.getFieldsValue(true);

    const params = {
      permiteContato: formValues.pessoa?.autorizaContato,
      cpf: form.getFieldValue(["pessoa", "cpf"]),
    };
    try {
      const response = service.getDeclaResponbilidade(params);
      setEmissaoDeclaracao(true);
    } catch (error) {
      console.error(error);
    }
  };

  const toMomentOrNull = (value) => {
    if (!value) return null;
    if (moment.isMoment(value)) return value;

    const m = moment(
      value,
      ["YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601],
      true
    );

    return m.isValid() ? m : null;
  };

  const documentoApresentado = Form.useWatch("documentoApresentado", form);
  const descricaoDocumento = documentoApresentado?.descricao;

  const [tipoConfirmacao, setTipoConfirmacao] = useState("RECADASTRAMENTO");

  const [dadosRetificacao, setDadosRetificacao] = useState(null);

    const [veioDeRetificacao, setVeioDeRetificacao] = useState(
    location?.state?.retificacao || false
  );

  const resetarFluxoRetificacao = () => {
    setTipoConfirmacao("RECADASTRAMENTO");
    setDadosRetificacao(null);

    setRecadastramento(false);
    setEmissaoDeclaracao(false);

    setVeioDeRetificacao(false);

    // limpa mensagens de erro/alerta
    setValoresForm((prev) => ({
      ...sanitizeDeep(prev),
      //id: null,
      referencia: null,
      mensagens: [],
    }));
  };

  //const veioDeRetificacao = location?.state?.retificacao || false;


  const podeEmitirComprovante =
    valoresForm?.id &&
    valoresForm?.dataConclusao &&
    !veioDeRetificacao &&
    tipoConfirmacao !== "RETIFICAR";

  const salvarCarteira = async (carteira) => {
    const { data } = await service.salvarCarteiraTrabalho({
        ...carteira,
         pessoaId: form.getFieldValue(["pessoaBanco", "id"])
    });

    return data;
  };

  const excluirCarteira = async (id) => {
      await service.excluirCarteiraTrabalho(id);
  };

  return (
    <>
      <Secured
        hasAnyRole={Permissions.RECADASTRAMENTO.TELA}
        isShowErro403={true}
      >
        {erroObrigatorio && (
          <Alert
            message="Verifique os campos obrigatórios que não foram preenchidos."
            type="warning"
            showIcon
            closable
            onClose={() => setErroObrigatorio(false)}
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1000,
              marginBottom: 16,
            }}
          />
        )}

        <Form
          name="censo"
          form={form}
          onFinish={confirmarRecadastramento}
          onFinishFailed={handleErroValidacao}
        >
          <Card
            title="Benefício(s)"
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              paddingBottom: "10px",
              marginBottom: "1%",
            }}
            hidden={ocultarEtapa2}
          >
            <div style={{ float: "left", width: "calc(100% - 240px)" }}>
              <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ flex: 2 }}>
                  <Form.Item name={["pessoa", "nome"]} label="Nome">
                    <Input disabled />
                  </Form.Item>
                </div>

                <div style={{ flex: 1 }}>
                  <Form.Item
                    name={["pessoa", "cpf"]}
                    label="CPF"
                    className="cpf-sem-lupa"
                  >
                    <InputCPF enterButton={false} readOnly />
                  </Form.Item>
                </div>
              </div>

              <div style={{ width: "20%", maxWidth: "200px" }}>
                  <Form.Item name={["pessoa", "nascimento"]} label="Data de Nascimento">
                    <DatePicker
                      disabled
                      format="DD/MM/YYYY"
                      style={{ width: "20%" }}
                    />
                  </Form.Item>
              </div>

              <div style={{ marginTop: "20px" }}>
                {valoresForm?.beneficios?.map((item, index) => (
                  <div key={index} style={{ width: "50%" }}>
                    <StatusBeneficios item={item} />
                  </div>
                ))}
              </div>
            </div>

            <div style={{ float: "right", width: "220px" }}>
              <Col
                xs={22}
                sm={22}
                md={24}
                lg={24}
                hidden={ocultarEtapa2}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Card
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    padding: 0,
                  }}
                  bodyStyle={{ padding: 0 }}
                >
                  <img
                    src={ultimaFotoCensoBase64 || imagemAvatar}
                    alt="Foto"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Card>
              </Col>
            </div>

            {/* Clear floats */}
            <div style={{ clear: "both" }} />

            {/* Alertas */}
            <Row style={{ marginTop: "10px" }}>
              {valoresForm?.mensagens?.map((item, index) => (
                <Alert
                  key={index}
                  message={statusAlert[Object.keys(item)[0]].titulo}
                  description={Parser(item[Object.keys(item)[0]])}
                  type={statusAlert[Object.keys(item)[0]].tipo}
                  showIcon
                />
              ))}
            </Row>

            <Row type="flex" justify="end" style={{ marginTop: "2%" }}>
              <Col>
                <button
                  type="button"
                  className="btn btn-outline-dark mr-2"
                  onClick={() => {
                    cancelar();
                  }}
                >
                  <i className="fa fa-eraser" />
                  Limpar Busca
                </button>
              </Col>

              <Col>
                <button
                  type="button"
                  className="btn btn-outline-success mr-2"
                  onClick={() => setMostrarModalHistorico(true)}
                >
                  <i className="fa fa-search" />
                  Histórico
                </button>
              </Col>

              {podeEmitirComprovante && (
                <Col>
                  <button
                    type="button"
                    className="btn btn-outline-success mr-2"
                    onClick={() => emitirComprovante(valoresForm.id)}
                  >
                    <i className="fa fa-file" />
                    Comprovante
                  </button>
                </Col>
              )}

              {!modoSomenteLeitura && (
                <>
                  <Col hidden={ocultarEtapa2 || !ocultarEtapa3}>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        setMostrarModalConfirmacao(true);
                      }}
                      hidden={!valoresForm?.permiteLancamentoRetroativo}
                    >
                      <i className="fa fa-user-check" />
                      Iniciar Recadastramento {valoresForm?.referenciaRetroativa}
                    </button>
                  </Col>

                  <Col hidden={ocultarEtapa2 || !ocultarEtapa3}>
                    <button
                      type="button"
                      className="btn btn-info"
                      onClick={() => {
                        setMostrarModalConfirmacao(true);
                      }}
                      hidden={!valoresForm?.permiteRealizar}
                      style={{ marginLeft: "8px" }}
                    >
                      <i className="fa fa-user-check" />
                      Iniciar Recadastramento {valoresForm?.referencia}
                    </button>
                  </Col>
                </>
              )}


            </Row>
          </Card>

          {ocultarEtapa2 ? (
            <Card
              title="Identificação do Segurado"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <IdentificacaoPessoa
                form={form}
                nome="pessoa"
                handleValoresCPF={handleValoresCPF}
                onClear={cancelar}
                onHandleRequerRepresentante={setRequerRepresentante}
                desabilitarCampos={!ocultarEtapa2 && ocultarEtapa3}
                desabilitarCPF={!ocultarEtapa2 || !ocultarEtapa3}
                ocultarCampos={ocultarEtapa2}
                onRetificar={retificarCPF}
                ocultarEtapa2={ocultarEtapa2}
                ocultarEtapa3={ocultarEtapa3}
                recadastramento={recadastramento}
                emissaoDeclaracao={emissaoDeclaracao}
                setEmissaoDeclaracao={setEmissaoDeclaracao}
              />
            </Card>
          ) : (
            !ocultarEtapa3 && (
              <Card
                title="Identificação do Segurado"
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <IdentificacaoBase
                  documentoApresentado={descricaoDocumento}
                  modoSomenteLeitura={modoSomenteLeitura}
                  disabled={modoSomenteLeitura}
                  form={form}
                  recadastramento={true}
                  nomePrefix={["pessoaBanco"]}
                  onSearchCPF={handleValoresCPF}
                  desabilitarCPF={!!pessoaId}
                  handleValoresCPF={handleValoresCPF}
                  onClear={cancelar}
                  salvarCarteira={salvarCarteira}
                  excluirCarteira={excluirCarteira}
                />
                {possuiAposentadoria && (
                  <div style={{ marginTop: "1%" }}>
                    <button
                      type="button"
                      className="btn btn-outline-dark mr-2"
                      onClick={() => setMostrarModalDependente(true)}
                    >
                      <i className="fas fa-user" />
                      Dependentes
                    </button>
                  </div>
                )}
              </Card>
            )
          )}

          <div hidden={ocultarEtapa3}>
            <Painel subTitulo="Endereço">
              <Endereco nome="endereco" form={form} status={controleEtapa2} />
            </Painel>
          </div>

          <div hidden={ocultarEtapa3}>
            <Painel subTitulo="Contato(s)">
              <Contato nome="contato" />
            </Painel>
          </div>

          {!ocultarEtapa3 && <PermiteContato nome="pessoa" form={form} />}

          <Row style={{ marginTop: "1.0%" }}>
            <Col xs={26} sm={26} md={18} lg={18} hidden={ocultarEtapa3}>
              <Card title="Documentos necessários">
                {recadastramento && !emissaoDeclaracao ? (
                  <span>
                    <p style={{ color: "red", textAlign: "center" }}>
                      Para anexar o documento, é necessário primeiro emitir a
                      Declaração de Responsabilidade, que se encontra logo abaixo.
                    </p>
                  </span>
                ) : null}
                <Row gutter={[10, 10]} align="stretch" justify="center">
                  <Col
                    xs={23}
                    sm={23}
                    md={23}
                    lg={23}
                    style={{ marginTop: "0.5%" }}
                  >
                    <Form.Item
                      name="arquivoCertidao"
                      rules={[
                        {
                          required: true,
                          message: "Por favor, insira o documento!",
                        },
                      ]}
                    >
                      <Card
                        style={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                        }}
                        cover={
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {/* Condicionalmente exibe o ícone e texto com base no estado do arquivo */}
                            {certidaoBase64 ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%",
                                }}
                              >
                                <CheckCircleOutlined
                                  style={{ color: "green", marginRight: 8 }}
                                />

                                <div>Certidão Selecionada!</div>
                                <Progress percent={100} size="small" />
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%",
                                }}
                              >
                                <ExclamationCircleOutlined
                                  style={{ color: "orange", marginRight: 8 }}
                                />
                                <div>Selecione um Arquivo</div>
                                <Progress
                                  percent={2}
                                  size="small"
                                  status="exception"
                                />
                              </div>
                            )}
                          </div>
                        }
                        actions={[
                            <div
                              style={{
                                display: "flex",
                                gap: "24px",
                                width: "100%",
                                alignItems: "stretch",
                              }}
                            >
                                                            {/* Declaração Responsabilidade */}
                              {recadastramento && (
                                <div style={{ flex: 1 }}>
                                  <Popover
                                    content="A declaração será liberada após o preenchimento do campo de permissão para contato."
                                    trigger="hover"
                                    open={
                                      permiteContato == null
                                        ? undefined
                                        : false
                                    }
                                  >
                                    <span style={{ display: "block", width: "100%" }}>
                                      <Button
                                        type="primary"
                                        block
                                        style={{
                                          height: "32px",
                                          fontWeight: "bold",
                                          backgroundColor: "#13a8a8",
                                          borderColor: "#13a8a8",
                                        }}
                                        onClick={imprimirDeclaResponsabilidade}
                                        disabled={permiteContato == null}
                                      >
                                        <i className="fa fa-file mr-2" />
                                        Declaração Responsabilidade
                                      </Button>
                                    </span>
                                  </Popover>
                                </div>
                              )}
                              <div style={{ flex: 1 }}>
                                  {recadastramento && !emissaoDeclaracao ? (
                                    <Popover
                                      content="Para anexar o documento, é necessário primeiro emitir a Declaração de Responsabilidade, que se encontra ao lado."
                                      trigger="hover"
                                    >
                                      <span>
                                        <Button
                                          type="primary"
                                          block
                                          style={{
                                            fontWeight: "bold",
                                            backgroundColor: "#1677ff",
                                            borderColor: "#1677ff",
                                          }}
                                          onClick={() =>
                                            document
                                              .getElementById("upload-certidao")
                                              .click()
                                          }
                                          disabled
                                        >
                                          Anexar Arquivo
                                        </Button>
                                      </span>
                                    </Popover>
                                  ) : (
                                    <span>
                                      <Button
                                        type="primary"
                                        block
                                        style={{
                                          fontWeight: "bold",
                                          backgroundColor: "#1677ff",
                                          borderColor: "#1677ff",
                                        }}
                                        onClick={() =>
                                          document
                                            .getElementById("upload-certidao")
                                            .click()
                                        }
                                      >
                                        Anexar Arquivo
                                      </Button>
                                    </span>
                                  )}
                              </div>
                              {/* Baixar Arquivo */}
                              <div style={{ flex: 1 }}>
                                <Button
                                  type="primary"
                                  block
                                  style={{
                                    height: "32px",
                                  }}
                                  onClick={() =>
                                    downloadArquivo(
                                      certidaoBase64,
                                      "certidao.pdf"
                                    )
                                  }
                                  disabled={!certidaoBase64}
                                >
                                  Baixar Arquivo
                                </Button>
                              </div>
                            </div>,
                          ]}
                          
                      >
                        <input
                                type="file"
                                accept=".pdf"
                                style={{ display: "none" }}
                                id="upload-certidao"
                                onChange={async (e) => {
                                  const file = e.target.files?.[0];
                                  if (file) {
                                    const reader = new FileReader();
                                    reader.onloadend = () => {
                                      setCertidaoBase64(reader.result);
                                    };
                                    reader.readAsDataURL(file);
                                    handleChangeDocumento(
                                      { fileList: [file], file },
                                      "Certidao"
                                    );
                                  }
                                }}
                        />
                      </Card>
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>

            <Col
              xs={22}
              sm={22}
              md={6}
              lg={6}
              hidden={ocultarEtapa3}
              style={{ display: "flex", alignItems: "stretch" }}
            >
              <Card
                style={{
                  width: "100%",
                  height: "100%",
                  maxHeight: "233px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  padding: 0,
                  margin: "0 auto",
                }}
                bodyStyle={{ padding: 0 }}
                onClick={() => setModalFotoEstaAberto(true)}
              >
                <img
                  src={fotoBase64 || imagemAvatar}
                  alt="Foto"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain", // mostra a imagem inteira, mesmo que com margens
                    display: "block",
                  }}
                />
              </Card>
            </Col>
          </Row>

          <Row
            type="flex"
            justify="end"
            style={{
              marginTop: "12px",
              display: ocultarEtapa3 ? "none" : "block",
            }}
          >
            <Col>
              <button
                type="button"
                className="btn btn-outline-dark mr-2"
                onClick={cancelar}
              >
                <i className="fa fa-times" />
                Cancelar
              </button>
              <button type="submit" className="btn btn-info">
                <i className="fa fa-user-check" />
                Finalizar Recadastramento
              </button>
            </Col>
          </Row>

          <Form.Item name="documentoApresentado" hidden>
            <Input />
          </Form.Item>
          <ModalConfirmacaoRecadastramento
            show={mostrarModalConfirmacao}
            form={form}
            maskClosable={false}
            onCancel={() => {
              resetarFluxoRetificacao();
              setMostrarModalConfirmacao(false);
            
            }}
            onConfirm={() => {
              if (tipoConfirmacao === "RETIFICAR") {
                const { id, anoReferencia } = dadosRetificacao;
                setOcultarEtapa3(false);
                setRecadastramento(false);

                const doc = form.getFieldValue(["documentoApresentado"]);

                setValoresForm((prev) => ({
                  ...prev,
                  id: id,
                  referencia: anoReferencia,
                  documentoApresentado: doc,
                }));
                valoresForm["mensagens"] = [];

                retificarCPF(
                  id,
                  anoReferencia,
                  form.getFieldValue(["pessoa", "cpf"])
                );
              } else {
                setRecadastramento(true);
                setOcultarEtapa3(false);

                obterCPF(form.getFieldValue(["pessoa", "cpf"]));
              }

              setMostrarModalConfirmacao(false);
              //setTipoConfirmacao("RECADASTRAMENTO");
            }}
          />
        </Form>
        {mostrarModalHistorico && (
          <ModalHistorico
            show
            close={() => setMostrarModalHistorico(false)}
            modoSomenteLeitura={modoSomenteLeitura}
            onRetificar={(id, anoReferencia) => {
              setTipoConfirmacao("RETIFICAR");
              setDadosRetificacao({
                id,
                anoReferencia,
                documentoApresentado: form.getFieldValue(
                  "documentoApresentado"
                ),
              });
              setMostrarModalHistorico(false);
              setMostrarModalConfirmacao(true);
            }}
            cpf={form.getFieldValue(["pessoa", "cpf"])}
            nome={form.getFieldValue(["pessoa", "nome"])}
          />
        )}
        {modalFotoEstaAberto && (
          <ModalFoto
            open={modalFotoEstaAberto}
            close={() => setModalFotoEstaAberto(false)}
            setFoto={setFotoBase64}
          />
        )}

        {mostrarModalDependente && (
          <ModalDependente
            somenteVisualizacao={modoSomenteLeitura}
            show={mostrarModalDependente}
            close={() => setMostrarModalDependente(false)}
            cpf={form.getFieldValue("pessoa")?.cpf}
            pessoaTitular={
              form.getFieldValue("pessoa") ? form.getFieldValue("pessoa") : null
            }
          />
        )}

        <BloqueioJuntaMedica
          visivel={mostrarBloqueio}
          mensagem={mensagemErro}
          onFechar={() => setMostrarBloqueio(false)}
        />

        <BloqueioProvaDeVida
          visivel={mostrarBloqueioProvaDeVida}
          mensagem={mensagemErro}
          onFechar={() => setMostrarBloqueioProvaDeVida(false)}
        />
      </Secured>
    </>
  );
};

export default Recadastramento;
